import { createApi } from '@reduxjs/toolkit/query/react';

import { portalQuery } from '@api/api.config';

import { TagTypesEnum } from '@enum/tag-types.enum';
import { ResponseDataInterface } from '@interface/logs/response-data.interface';

export const mfaApi = createApi({
  reducerPath: 'mfa-api',
  tagTypes: [TagTypesEnum.User],
  baseQuery: portalQuery('/auth/mfa'),
  endpoints: (build) => ({
    generateMfa: build.mutation<ResponseDataInterface<string>, undefined>({
      query: () => ({
        method: 'POST',
        url: 'generate',
      }),
    }),
    enableMfa: build.mutation<ResponseDataInterface<boolean>, { otp: string }>({
      query: (body) => ({
        method: 'PUT',
        url: 'enable',
        body,
      }),
      invalidatesTags: [TagTypesEnum.User],
    }),
    disableMfa: build.mutation<ResponseDataInterface<boolean>, { otp: string }>({
      query: (body) => ({
        method: 'PUT',
        url: 'disable',
        body,
      }),
      invalidatesTags: [TagTypesEnum.User],
    }),
  }),
});
